/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";

const LabFilterModal = ({ show, labTestList, handleClose, filters }) => {
    const [selectedFilters, setSelectedFilters] = useState(filters || []);
    const filteredTests = labTestList.filter(
        (test) => Array.isArray(test.options) && test.options.length > 0
    );
    function generateId() {
        let id = "";
        let characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < 8; i++) {
            id += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return id;
    }

    const handleFilterChange = (selected, test) => {
        setSelectedFilters((prevFilters) => {
            // ✅ Remove existing filter for the same test
            let updatedFilters = prevFilters.filter(
                (item) => item.testId !== test._id
            );

            if (selected && selected.length > 0) {
                // ✅ Add new selected values
                const newFilters = selected.map((s) => ({
                    ...s,
                    testId: test._id,
                    value: `${test.name} ${s.label}`,
                }));

                updatedFilters = [...updatedFilters, ...newFilters];
            }

            return updatedFilters;
        });
    };

    const getAvailableOptions = (test) => {
        const selectedOptions = selectedFilters
            .filter((filter) => filter.testId === test._id)
            .map((filter) => filter.label);
        return test.options.filter((option) => !selectedOptions.includes(option.label));
    };

    const handleSaveModal = () => {
        const updatedFilters = selectedFilters.map((ele) => ({ ...ele, category: "LabTest", id: generateId() }))
        handleClose(updatedFilters)
    }

    console.log(labTestList, selectedFilters, "lTL")
    return (
        <>
            <Modal show={show} onHide={handleClose} centered dialogClassName="modal-xl">
                <Modal.Header closeButton className="bg-thumbcolor">
                    <Modal.Title>Lab Filters</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="filter-container">
                        <div className="row">
                            {filteredTests.map((test) => (
                                <div className="col-md-4 mt-3" key={test._id}>
                                    <label>
                                        {test.name} {test.unit && `(${test.unit})`}
                                    </label>
                                    {Array.isArray(test.options) ? (
                                        <Select
                                            options={getAvailableOptions(test)}
                                            multi={true}
                                            value={selectedFilters.filter((obj) => obj.testId === test._id) || []}
                                            onChange={(selected) =>
                                                handleFilterChange(selected, test)
                                            }
                                            isClearable
                                            isSearchable

                                        />
                                    ) : (
                                        <div className="text-muted">
                                            {test.options || "No options available"}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleSaveModal} >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default LabFilterModal


